module.exports = __webpack_public_path__ + "static/img/tycp.c164afa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tycp.png
// module id = XYf+
// module chunks = 101